<template>
	<div>
		<h1>Kontierung</h1>

		<button @click="addEntryRecordShowDlg"><i class="fas fa-plus"></i> Buchung hinzufügen</button>

		<!--div class="filter">
			<select v-model="filter.status">
				<option value="">-- alle Stati anzeigen --</option>
				<option value="fa-circle">Unbearbeitet (rot)</option>
				<option value="fa-exclamation-triangle">Warnung (orange)</option>
				<option value="fa-asterisk">Neu hinzugefügt</option>
				<option value="fa-link">Kopiert</option>
				<option value="fa-check-circle">Erledigt (grün)</option>
			</select>
		</div-->

		<table>
			<thead>
				<th></th>
				<th>Bu-Datum</th>
				<th>Valuta</th>
				<th>+/-</th>
				<th>Text</th>
				<th>Soll</th>
				<th>Haben</th>
				<th>Betrag <i class="fas fa-calculator" @click="showAmountSum()"></i></th>
				<th>Beleg</th>
				<th></th>
				<th>OK</th>
				<th></th>
				<th></th>
				<th></th>
			</thead>
			<tbody>
				<tr v-for="(rec,idx) in recs" :key="idx" :class="{approved: rec.approved}">
					<td><i class="fas" :class="rowIcon(rec)" :title="rec.hasOwnProperty('warning') ? rec.warning : ''"></i></td>
					<!--td><i class="fas" :class="rec.status_icon" :title="rec.hasOwnProperty('warning') ? rec.warning : ''"></i></td-->
					<td><input type="text" :value="rec.entry_date | date_format" @change="dateChng(idx, $event.target.value, 'e')" class="datefld"/></td>
					<td><input type="text" :value="rec.value_date | date_format" @change="dateChng(idx, $event.target.value, 'v')" class="datefld"/></td>
					<td><span v-if="rec.hasOwnProperty('revenue')" class="badge" :class="rec.revenue ? 'in' : 'out'" :title="rec.revenue | type_label"><i class="fas" :class="rec.revenue ? 'fa-plus' : 'fa-minus'"></i></span></td>
					<td><input type="text" v-model="rec.txt_user_input" class="txtfld"/></td>
					<td>
						<div class="acctvat">
							<input type="text" class="acctfld" v-model.trim="rec.debit_acct" @change="checkAcct(idx, 'debit')" placeholder="Konto" :title="acct_name_lookup.hasOwnProperty(rec.debit_acct) ? acct_name_lookup[rec.debit_acct] : ''"/>
							<div class="btn" @click="selectShowDlg(idx, 'acct', 'debit')">
								<i class="far fa-list-alt"></i>
							</div>
							<input type="text" class="vatfld" v-model.trim="rec.debit_vat" @change="checkVAT(idx, 'debit')" placeholder="Mwst" :title="vat_name_lookup.hasOwnProperty(rec.debit_vat) ? vat_name_lookup[rec.debit_vat] : ''" :disabled="rec.credit_vat !== ''"/>
							<div class="btn" :class="rec.credit_vat !== '' ? 'disabled': ''" @click="selectShowDlg(idx, 'vat', 'debit')">
								<i class="far fa-list-alt"></i>
							</div>
						</div>
					</td>
					<td>
						<div class="acctvat">
							<input type="text" class="acctfld" v-model.trim="rec.credit_acct" @change="checkAcct(idx, 'credit')" placeholder="Konto" :title="acct_name_lookup.hasOwnProperty(rec.credit_acct) ? acct_name_lookup[rec.credit_acct] : ''"/>
							<div class="btn" @click="selectShowDlg(idx, 'acct', 'credit')">
								<i class="far fa-list-alt"></i>
							</div>
							<input type="text" class="vatfld" v-model.trim="rec.credit_vat" @change="checkVAT(idx, 'credit')" placeholder="Mwst" :title="vat_name_lookup.hasOwnProperty(rec.credit_vat) ? vat_name_lookup[rec.credit_vat] : ''" :disabled="rec.debit_vat !== ''"/>
							<div class="btn" :class="rec.debit_vat !== '' ? 'disabled': ''" @click="selectShowDlg(idx, 'vat', 'credit')">
								<i class="far fa-list-alt"></i>
							</div>
						</div>
					</td>
					<td><input type="text" :value="rec.amount | number_format" @change="changeAmt(idx, $event.target.value)" class="amountfld"/></td>
					<td class="vouchercell">
						<select v-model="rec.voucher">
							<option value="NO">Nein</option>
							<option value="PENDING">Pendent</option>
							<option value="YES">Ja</option>
						</select>
						<input type="text" v-model="rec.voucher_ref" v-show="rec.voucher === 'YES'"/>
					</td>
					<td><i class="fas fa-money-bill-alt" :class="{hilight: parseInt(rec.payment_for) === -1, disable: parseInt(rec.payment_for) === 0}" title="Zahlung einem OP zuweisen" @click="paymentShowDlg(idx)"></i></td>
					<td><input type="checkbox" v-model="rec.approved" :disabled="rec.debit_acct === '' || rec.credit_acct === ''"/></td>
					<td><i class="fas fa-info-circle" title="Original-Buchungstext anzeigen" @click="origDataShowDlg(idx)"></i></td>
					<td><i class="far fa-copy" title="Kopieren" @click="copyRec(idx)"></i></td>
					<td><i class="fas fa-trash-alt" title="Löschen" @click="deleteShowDlg(idx)"></i></td>
				</tr>
			</tbody>
		</table>
		<div class="tblPager">
			<button @click="tblGotoFirst">|&lt;</button>
			<button @click="tblGoto(-1)">&lt;</button>
			<span>{{ table_page }} von {{ table_pages }}</span>
			<button @click="tblGoto(1)">&gt;</button>
			<button @click="tblGotoLast">&gt;|</button>
		</div>

		<div class="mainButtons">
			<button @click="approveAllRecs">Alle Bu freigeben</button>
			<button class="btnRevokeAllRecs" @click="revokeAllRecs">Alle Freigaben widerrufen</button>
			<button @click="btnPrev">&lt;&lt; Zurück</button>
			<button @click="cancelImportShowDlg">Import abbrechen</button>
			<button @click="btnNext">Weiter &gt;&gt;</button>
		</div>
		
		<vue-snotify></vue-snotify>
		
		<modal name="modalDel" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Löschung bestätigen</div>
			<div class="delConf-content">
				Buchung wirklich löschen?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="deleteRec" class="delConf-btn-del">Löschen</button>
				<button @click="$modal.hide('modalDel')">Abbrechen</button>
			</div>
		</modal>
		
		<modal name="modalAbortImport" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Import abbrechen</div>
			<div class="delConf-content">
				Wenn der Import abgebrochen wird, werden die Daten nicht gespeichert.<br><br>Trotzdem abbrechen?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="cancelImport" class="delConf-btn-del">Import abbrechen</button>
				<button @click="$modal.hide('modalAbortImport')">Schliessen</button>
			</div>
		</modal>
		
		<modal name="modalSelection" width="350" height="auto" :clickToClose="false" draggable=".delConf-title" @opened="$refs.selsrch.focus()">
			<div class="delConf-title">{{ selection.title }} auswählen</div>
			<div class="delConf-content selectdlg">
				<input type="text" v-model="selection.searchtxt" placeholder="Suche..." ref="selsrch" /><br>
				<select size="8" v-model="selection.selected">
					<option v-for="(rec,idx) in selection_items" :key="idx" :value="rec.id">[{{ rec.id }}] {{ rec.name }}</option>
				</select>
			</div>
			<div class="delConf-button-wrapper">
				<button @click="selectInsert" :disabled="selection.selected === ''">Auswählen</button>
				<button @click="$modal.hide('modalSelection')">Abbrechen</button>
			</div>
		</modal>
		
		<modal name="modalNew" width="500" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Hinweis</div>
			<div class="delConf-content selectdlg">
				Bitte beachten, dass neu hinzugefügte Buchungen ganz am Schluss der Liste "angehängt" werden.<br><br>
				Falls die aktuelle Tabellenansicht nicht der letzten Seite entspricht, wird die Tabellenseite automatisch angepasst. Die hinzugefügte Buchung befindet sich dann ganz am Schluss. Eventuell muss zum neuen Datensatz gescrollt werden.
			</div>
			<div class="delConf-button-wrapper">
				<button @click="addEntryRecord">Fortfahren</button>
				<button @click="$modal.hide('modalNew')">Abbrechen</button>
			</div>
		</modal>
		
		<modal name="modalOrigData" width="500" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Original-Buchungstext</div>
			<div class="delConf-content selectdlg">
				{{ original_txt }}
			</div>
			<div class="delConf-button-wrapper">
				<button @click="$modal.hide('modalOrigData')">Schliessen</button>
			</div>
		</modal>
		
		<modal name="modalPayment" width="500" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">{{ modalPaymentDlgTitle }}</div>
			<div class="delConf-content selectdlg">
				Datum: {{ payment_dlg.date | date_format }}<br>
				<br>
				{{ modalPaymentDlgTitle }}: {{ payment_dlg.amount | number_format }}<br>
				<br>
				Offene Posten:<br>
				<select v-model="payment_dlg.payment_for">
					<option value="0">-- keine Zuweisung --</option>
					<option v-for="op in payment_dlg.ops" :value="op.id" :key="op.id">{{ op.pa_name }}, {{ op.date | date_format }}, {{ op.name }}, {{ op.ccy }} {{ op.amount | number_format }}</option>
<!--d.`id`, d.`date`, a.`name` AS `pa_name`, d.`name`, d.`type`, IF(d.`refnum`=0,'',d.`refnum`) AS `refnum`, ccy.`iso_code` AS `ccy`, d.`amount`, d.`debit_acct`, d.`credit_acct`, d.`payment_pending`, d.`status`, d.`doc_checksum`-->
				</select>
<!--				Hier Liste mit OPs anzeigen (entweder Debi oder Kredi... aber nicht beides)<br>
				Bereits gespeicherter OP auf jeden Fall in der Liste aufführen, egal ob noch offen oder nicht<br>
				Liste sortiert nach Differenz zum RE-Betrag: gleiche Beträge zuerst, grösste Diff zuletzt-->
			</div>
			<div class="delConf-button-wrapper">
				<button @click="paymentSave()">OK</button>
				<button @click="$modal.hide('modalPayment')">Abbrechen</button>
			</div>
		</modal>
	</div>
</template>

<script>
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'

  export default {
    components: {},
    mixins: [ApiComm],
	data() {
		return {
			selected_rid: 0,
			table_page: 1,
			recs: [],
			acct_recs: [],
			vat_recs: [],
			acct_name_lookup: {},
			vat_name_lookup: {},
			original_txt: '',
			filter: {
				status: ''
			},
			selection: {
				title: '',
				searchtxt: '',
				selected: '',
				type: '', // 'acct' oder 'vat'
				side: '' // 'debit' oder 'credit'
			},
			payment_dlg: {
				rid: 0,
				revenue: false,
				date: '',
				amount: 0,
				payment_for: 0,
				ops: []
			}
		}
	},
	computed: {
		client_id () {
			return this.$store.state.customer.id;
		},
		
		table_pages: function () {
			return Math.ceil(this.$store.state.import.rows.length / 25)
		},
		
		modalPaymentDlgTitle: function () {
			return this.payment_dlg.revenue ? 'Zahlungseingang' : 'Zahlungsausgang';
		},
/*
		rows_processed: function () {
			var i, o = this.recs, n = o.length, ret = []
			
			for (i=0; i<n; i++) {
				o[i]['status_icon'] = this.rowIcon(o[i])
				if (this.filter.status === '' || (this.filter.status !== '' && o[i]['status_icon']===this.filter.status)) ret.push(o[i])
			}
			
			return ret;
		},
*/
		selection_items: function () {
			var stxt = this.selection.searchtxt.toLowerCase()
			var recs = this.selection.type === 'acct' ? this.acct_recs : this.vat_recs
			if (stxt === '') {
				return recs
			} else {
				var filtered = []
				var i
				for(i=0; i < recs.length; i++) {
					if (recs[i].id.toLowerCase().indexOf(stxt) > -1 || recs[i].name.toLowerCase().indexOf(stxt) > -1)
						filtered.push(recs[i])
				}
				return filtered
			}
		}
	},
	methods: {
		paymentShowDlg(rid) {
			this.payment_dlg.rid = rid;
			this.payment_dlg.date = this.recs[rid].entry_date;
			this.payment_dlg.revenue = this.recs[rid].revenue;
			this.payment_dlg.amount = this.recs[rid].amount;
			this.payment_dlg.payment_for = this.recs[rid].payment_for;
			
			this.apiCall([{method: 'arap/document/list', param: {client_id: this.client_id, mode: 'op', type: this.recs[rid].revenue ? 'ar' : 'ap', amount: this.recs[rid].amount}, id: 10}], this.evalApiResponse);
		},

		paymentSave() {
//			console.log('Hi World');
			this.recs[this.payment_dlg.rid].payment_for = this.payment_dlg.payment_for;
			this.$modal.hide('modalPayment');
//			this.recs.push({});
//			this.recs.pop();
		},

		showAmountSum: function () {
			var sum = 0.0, i, o = this.$store.state.import.rows, n = o.length
			this.saveTblContentGlobally()
			for (i=0; i<n; i++) {
				sum += parseFloat(o[i].amount)
			}
			//alert('Summe aller Beträge: ' + sum.toFixed(2))
			alert('Summe aller Beträge: ' + new Intl.NumberFormat('de-CH', {minimumFractionDigits: 2}).format(sum))
		},
		selectShowDlg: function (rid, type, side) {
			var s = this.selection
			s.selected = ''
			if (type === 'vat') {
				if (side === 'debit' && this.recs[rid].credit_vat !== '') return
				if (side === 'credit' && this.recs[rid].debit_vat !== '') return
				s.selected = side === 'debit' ? this.recs[rid].debit_vat : this.recs[rid].credit_vat
			} else {
				s.selected = side === 'debit' ? this.recs[rid].debit_acct : this.recs[rid].credit_acct
			}

			this.selected_rid = rid

			s.title = type === 'vat' ? 'MWST-Code' : 'Fibu-Konto'
			s.searchtxt = ''
			s.type = type
			s.side = side

			this.$modal.show('modalSelection')
		},
		selectInsert: function () {
			var s = this.selection
			var is_debit = s.side === 'debit'
			var rid = this.selected_rid
			if (s.type === 'vat') {
				if (is_debit) this.recs[rid].debit_vat = s.selected
				else this.recs[rid].credit_vat = s.selected
			} else {
				if (is_debit)
					this.recs[rid].debit_acct = s.selected
				else
					this.recs[rid].credit_acct = s.selected
				this.checkAccount(rid, s.side, s.selected)
			}
			this.$modal.hide('modalSelection')
		},
		checkAccount: function (rid, side, acct) {
			//FIBU-Kto überprüfen und ggf. MWST-Code einfügen
			var i,vc
			for (i=0; i<this.acct_recs.length; i++) {
				if (this.acct_recs[i].id === acct) {
					vc = this.acct_recs[i].vat_code
					if (vc !== null) {
						if (side === 'debit') {
							if (this.recs[rid].credit_vat === '') this.recs[rid].debit_vat = vc
						} else {
							if (this.recs[rid].debit_vat === '') this.recs[rid].credit_vat = vc
						}
					}
					return true
				}
			}
			return false
		},
		checkAcct: function (rid, side) {
			if (this.recs[rid].debit_acct === '' || this.recs[rid].credit_acct === '') this.recs[rid].approved = false
			
			if (this.recs[rid].debit_acct !== '' && this.recs[rid].debit_acct === this.recs[rid].credit_acct)
				this.$snotify.error('Soll- und Haben-Konto dürfen nicht identisch sein', 'ERROR', {timeout: 8000})
			
			var acct = side === 'debit' ? this.recs[rid].debit_acct : this.recs[rid].credit_acct
			if (acct !== '' && !this.checkAccount(rid, side, acct))
				this.$snotify.error('Fibu-Konto "' + acct + '" ist ungültig', 'ERROR', {timeout: 8000})
		},
		checkVAT: function (rid, side) {
			var i, vat = side === 'debit' ? this.recs[rid].debit_vat : this.recs[rid].credit_vat
			if (vat === '') return
			for (i=0; i<this.vat_recs.length; i++) {
				if (this.vat_recs[i].id === vat) return
			}
			this.$snotify.error('MWST-Code "' + vat + '" ist ungültig', 'ERROR', {timeout: 8000})
		},
		dateChng: function (rid, val, type) {
			var d = this.$moment(val, 'DD.MM.YYYY')
			if (!d.isValid()) {
				this.$snotify.error('Das Datum "' + val + '" ist ungültig', 'ERROR', {timeout: 8000})
				return
			}
//			console.log(d.format('YYYY-MM-DD'))
			
			if (type === 'v') {
				this.recs[rid].value_date = d.format('YYYY-MM-DD')
			} else {
				this.recs[rid].entry_date = d.format('YYYY-MM-DD')
			}
		},
		changeAmt: function (rid, val) {
			this.recs[rid].amount = val
		},
		rowIcon: function (rec) {
			var copyfrom = rec.hasOwnProperty('copyfrom'), revenue = rec.hasOwnProperty('revenue'), warn = rec.hasOwnProperty('warning')

			if (copyfrom) {
				return 'fa-link'
			} else if (!revenue) { //Symbol für neuen Record
				return 'fa-asterisk'
			} else if (rec.approved) {
				return 'fa-check-circle'
			} else if (warn) {
				return 'fa-exclamation-triangle'
			} else {
				return 'fa-circle'
			}

/*
			if (warn) {
				return 'fa-exclamation-triangle'
			} else if (copyfrom) {
				return 'fa-link'
			} else if (!revenue) { //Symbol für neuen Record
				return 'fa-asterisk'
			} else {
				return 'fa-check-circle'
			}
*/
			//fa-circle <--ROT
		},
		approveAllRecs: function () {
			//FIBU-Kto überprüfen und ggf. MWST-Code einfügen
			var i
			for (i=0; i<this.recs.length; i++) this.recs[i].approved = true
		},
		revokeAllRecs: function () {
			//FIBU-Kto überprüfen und ggf. MWST-Code einfügen
			var i
			for (i=0; i<this.recs.length; i++) this.recs[i].approved = false
		},
		getAbsoluteRecIdx: function (rid) {
			return (this.table_page - 1) * 25 + rid
		},
		copyRec: function (rid) {
			var r = this.$_.cloneDeep(this.recs[rid])
			if (!r.hasOwnProperty('copyfrom')) r.copyfrom = this.getAbsoluteRecIdx(rid)
			if (r.hasOwnProperty('id')) delete r.id;
			r.debit_acct = ''
			r.debit_vat = ''
			r.credit_acct = ''
			r.credit_vat = ''
			r.amount = 0
			r.approved = false
			this.recs.splice(rid+1, 0, r)
			this.$store.state.import.rows.splice(r.copyfrom+1, 0, r)
		},
		tblGotoFirst: function () {
			this.saveTblContentGlobally()
			this.table_page = 1
			this.populateDT()
		},
		tblGoto: function (n) {
			this.saveTblContentGlobally()
			this.table_page += n
			this.populateDT()
		},
		tblGotoLast: function () {
			this.saveTblContentGlobally()
			this.table_page = Math.ceil(this.$store.state.import.rows.length / 25)
			this.populateDT()
		},
		deleteShowDlg: function (rid) {
			this.selected_rid = rid
			this.$modal.show('modalDel')
		},
		deleteRec: function () {
			this.$modal.hide('modalDel')
			this.recs.splice(parseInt(this.selected_rid), 1)
			this.$store.state.import.rows.splice((this.table_page - 1) * 25 + parseInt(this.selected_rid), 1)
		},
		populateDT: function () {
			var i
			this.recs = []
			var nrecs = 0
			for (i=(this.table_page - 1) * 25; i<this.$store.state.import.rows.length; i++) {
				//var x = this.$store.state.import.rows[i]
				var x = this.$_.cloneDeep(this.$store.state.import.rows[i])
				if (!x.hasOwnProperty('txt_user_input') || x.txt_user_input === 'NULL') x['txt_user_input'] = x.txt_original
				if (!x.hasOwnProperty('debit_acct')) x['debit_acct'] = ''
				if (!x.hasOwnProperty('debit_vat')) x['debit_vat'] = ''
				if (!x.hasOwnProperty('credit_acct')) x['credit_acct'] = ''
				if (!x.hasOwnProperty('credit_vat')) x['credit_vat'] = ''
				if (!x.hasOwnProperty('voucher')) x['voucher'] = 'YES'
				if (!x.hasOwnProperty('voucher_ref')) x['voucher_ref'] = ''
				if (!x.hasOwnProperty('approved')) x['approved'] = false
				
				//this.recs.push({entry_date: x.entry_date, value_date: x.value_date, txt_original: x.txt_original, txt_user_input: x.hasOwnProperty('txt_user_input') ? x.txt_user_input : x.txt_original, revenue: x.revenue, amount: x.amount, debit_acct:'', debit_vat:'', credit_acct:'', credit_vat:'', voucher:'NO', voucher_ref:'', approved:false})
				this.recs.push(x)
				nrecs++;
				if (nrecs >= 25) break
			}
		},
		origDataShowDlg: function (rid) {
			this.original_txt = this.recs[rid].txt_original
			this.$modal.show('modalOrigData')

		},
		addEntryRecordShowDlg: function () {
			this.$modal.show('modalNew')
		},
		addEntryRecord: function () {
			var d = this.$moment().format('YYYY-MM-DD')
			var r = {entry_date: d, value_date: d, txt_original: '', txt_user_input: '', amount: 0, debit_acct:'', debit_vat:'', credit_acct:'', credit_vat:'', voucher:'YES', voucher_ref:'', approved:false}
			this.$store.state.import.rows.push(r)
			this.tblGotoLast()
			this.$modal.hide('modalNew')
		},
		saveTblContentGlobally: function () {
			var i, offset = (this.table_page - 1) * 25
			for (i=0; i<this.recs.length; i++) {
				this.$store.state.import.rows[i+offset] = this.recs[i]
			}
		},
		cancelImportShowDlg: function () {
			this.$modal.show('modalAbortImport')
		},
		cancelImport: function () {
			this.$store.commit('set_import_param', {})
			this.$router.push({ path: '/home'})
		},
		btnPrev: function () {
			this.saveTblContentGlobally()
			this.$router.push({ path: '/home/import/upload'})
		},
		btnNext: function () {
			this.saveTblContentGlobally()
			this.$router.push({ path: '/home/import/parameter'})
		},
		evalApiResponse: function (resp) {
			var i, vm = this
			this.$_.forEach(resp, function (value) {
			  if (value.hasOwnProperty('id')) {
				switch (value.id) {
				  case 10: // 10 = Result from 'arap/document/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000});
					} else {
						vm.payment_dlg.ops = value.result;
						vm.$modal.show('modalPayment');
					}
					break
				  case 50: // 50 = Result from 'client/param/account/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						//vm.acct_recs = value.result
						vm.acct_recs = []
						for (i=0; i<value.result.length; i++) {
							vm.acct_recs.push({id: value.result[i].number, name: value.result[i].description, type: value.result[i].type, currency: value.result[i].currency, vat_code: value.result[i].vat_code})
							vm.acct_name_lookup[value.result[i].number] = value.result[i].description
						}
					}
					break
				  case 60: // 60 = Result from 'client/param/vat/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						//vm.vat_recs = value.result
						vm.vat_recs = []
						for (i=0; i<value.result.length; i++) {
							vm.vat_recs.push({id: value.result[i].code, name: value.result[i].description})
							vm.vat_name_lookup[value.result[i].code] = value.result[i].description
						}
					}
					break
				}
			  }
			})
		}
	},
    filters: {
		type_label: function (value) {
			return value === true ? 'Gutschrift' : 'Belastung'
		},
		number_format: function (value) {
			return parseFloat(value).toFixed(2)
		},
		date_format: function (value) {
			var a = value.split("-")
			return a.length < 3 ? '' : (a[2] + '.' + a[1] + '.' + a[0])
		}
	},
    mounted: function () {
		this.populateDT()
		var cid = this.$store.state.customer.id
		this.apiCall([{method: 'client/param/account/list', param: {client_id: cid}, id: 50},{method: 'client/param/vat/list', param: {client_id: cid}, id: 60}], this.evalApiResponse)
    }
  }
</script>

<style scoped="">
button {
	border: 1px solid #000;
	background: #888;
	color: #fff;
	margin-bottom: 20px;
	padding: 5px 10px;
	cursor: pointer;
	font-weight: 700;
}

button:hover {
	background: #666;
}

table {
	border-collapse: collapse;
	border: 1px solid #888;
	margin-bottom: 20px;
}

th {
	background: #317dff;
	color: #fff;
	padding: 10px 10px;
	min-width: 30px;
	text-align: left;
	border-bottom: 1px solid #888;
}

td {
	color: #333;
	padding: 10px 10px;
	text-align: left;
}

td:nth-child(1) {text-align: center}
th:nth-child(2), td:nth-child(2) {text-align: center}
th:nth-child(3), td:nth-child(3) {text-align: center}
th:nth-child(4), td:nth-child(4) {text-align: center}
th:nth-child(6), td:nth-child(6) {text-align: center}
th:nth-child(7), td:nth-child(7) {text-align: center}
th:nth-child(8), td:nth-child(8) {text-align: right}
th:nth-child(10), td:nth-child(10) {text-align: center}

tr:nth-child(even) {background: #eee}
tr:nth-child(odd) {background: #fff}

tr.approved {background: #a9ffa9}

td > i {
	cursor: pointer;
}

input[type=text], select {
	border: 1px solid #888;
	padding:3px;
	background: #fff;
}

.datefld {
	width: 90px;
}

.txtfld {
	width: 450px;
}

.amountfld {
	text-align: right;
	width: 80px;
}

.fa-link {
	cursor:auto;
	color:#00f;
}

.fa-asterisk {
	cursor:auto;
	color:#cb00ff;
}

.fa-exclamation-triangle {
	cursor:auto;
	color:#ff6b00;
}

.fa-check-circle {
	cursor:auto;
	color:#080;
}

.fa-circle {
	cursor:auto;
	color:#f00;
}

.badge {
	border-radius: 5px;
	padding: 3px 5px;
	color: #fff;
}

.badge.in {
	background: #080;
}

.badge.out {
	background: #c00;
}

.tblPager span {
	margin-left: 5px;
	margin-right: 10px;
}

.tblPager button {
	margin-right: 5px;
}

.mainButtons button {
	margin-right: 5px;
}

.acctvat {
	display: flex;
	border: 1px solid #888;
}

.acctvat input {
	border: none;
}

.acctvat .btn {
	cursor: pointer;
	background: #888;
	color: #fff;
	padding: 0 3px;
}

.acctvat .btn:hover {
	background: #666;
}

.acctvat .btn.disabled {
	cursor: auto;
	background: #888;
	color: #bbb;
}

.acctvat .btn.disabled:hover {
	background: #888;
}

.acctvat i {
	margin-top: 4px;
}

.acctfld {
	width: 60px;
}

.acctfld::placeholder {
	color: #888;
}

.vatfld {
	width: 50px;
}

.vatfld::placeholder {
	color: #888;
}

.vatfld:disabled::placeholder {
	color: #ddd;
}

.vatfld:disabled {
	background: #ddd;
}

.vouchercell input {
	margin-left: 5px;
	width: 150px;
}

/* CONFIRM DELETION*/
.delConf-title {
	cursor: move;
	font-weight: 700;
	line-height: 40px;
	border-bottom: 1px solid #aaa;
	padding: 0 10px;
}

.delConf-content {
	padding: 20px 10px;
}

.delConf-button-wrapper {
	border-top: 1px solid #aaa;
	padding: 10px 10px 0 10px;
}

.delConf-button-wrapper button {
	margin-left: 5px;
}

.delConf-btn-del {
	background: #c00;
}

.delConf-btn-del:hover {
	background: #a00;
}

.clientselect input, .clientselect select {
	width:100%;
	background: #fff;
	border: 1px solid #888;
	margin: 2px 0;
	padding: 3px;
}

.selectdlg input, .selectdlg select {
	width: 100%;
	margin: 1px 0;
}

.btnRevokeAllRecs {
	margin-right: 50px!important;
}

.fa-calculator {
	cursor: pointer;
}

.fa-money-bill-alt {
	color: #F00;
}

.fa-money-bill-alt.hilight {
	color: #FFA500;
	animation: blinker 2s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.fa-money-bill-alt.disable {
	color: #BBB;
}

/*
.filter {
	margin-bottom: 10px;
}
*/
</style>
